/**
 * YLI GA4 Article Tracking
 * Version: 2.0.0
 * Created: 2026-01-14
 * Updated: 2026-02-13
 * Purpose: Track blog article engagement with scroll depth and time tracking
 * GA4 Events: article_scroll
 * Spec: docs/operations/ga4-events/ga4-event-registry-and-implementation-guide.md
 *
 * Parameters sent:
 *   article_title  - Article heading text
 *   article_url    - Current page URL
 *   scroll_depth   - Numeric milestone (50, 75, 90)
 *   time_on_page   - Seconds spent on page at time of scroll event
 */

(function() {
  'use strict';

  // Only run on article pages
  const articleElement = document.querySelector('.article, [data-section-type="article"], article.rte');
  if (!articleElement) return;

  // Get article metadata
  const articleTitle = document.querySelector('.article__title, h1')?.textContent.trim() || 'Unknown';
  const articleUrl = window.location.href;

  // Tracking state
  let startTime = Date.now();
  let hasTracked50Percent = false;
  let hasTracked75Percent = false;
  let hasTracked90Percent = false;

  function getTimeOnPage() {
    return Math.floor((Date.now() - startTime) / 1000);
  }

  function sendScrollEvent(depth) {
    if (typeof gtag === 'function') {
      gtag('event', 'article_scroll', {
        'article_title': articleTitle,
        'article_url': articleUrl,
        'scroll_depth': depth,
        'time_on_page': getTimeOnPage()
      });
    }
  }

  // Track scroll depth at 50%, 75%, and 90% milestones
  function trackScrollDepth() {
    const scrollPercent = Math.round(
      (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100
    );

    if (scrollPercent >= 90 && !hasTracked90Percent) {
      hasTracked90Percent = true;
      sendScrollEvent(90);
    } else if (scrollPercent >= 75 && !hasTracked75Percent) {
      hasTracked75Percent = true;
      sendScrollEvent(75);
    } else if (scrollPercent >= 50 && !hasTracked50Percent) {
      hasTracked50Percent = true;
      sendScrollEvent(50);
    }
  }

  // Throttle scroll events
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
    scrollTimeout = setTimeout(trackScrollDepth, 150);
  }, { passive: true });

  // Initial scroll check (in case user loads mid-page)
  setTimeout(trackScrollDepth, 1000);

})();
